<template>
    <div>
        <table class="table" v-loading="$parentInfo.studentCourseRecord.loading">
            <thead>
            <tr>
                <th>合同编号</th>
                <th>时间</th>
                <th>总额</th>
                <th>状态</th>
                <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(studentInvoice,index) in orderStudentInvoices" :key="index">
                <td>{{studentInvoice.id}}</td>
                <td>{{studentInvoice.created_at}}</td>
                <td>{{studentInvoice.countPayment}}</td>
                <td v-if="studentInvoice.status==='abandon'">废弃</td>
                <td v-else>生效</td>
                <td>
                    <el-button size="small" @click="handleStudentInvoiceDetail(studentInvoice)">查看合同
                    </el-button>
                    <el-button size="small" @click="handleInvoiceBill(studentInvoice.id)">查看票据
                    </el-button>
                    <el-button size="small" @click="handleCancelInvoice(studentInvoice.id)" v-if="!$parentInfo.studentCourseRecord.disableYN"
                               :disabled="studentInvoice.status==='abandon'">取消合同
                    </el-button>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowStudentInvoice();
        },
        computed: {
            orderStudentInvoices: function () {
                return this._.orderBy(this.$parentInfo.studentCourseRecord.studentInvoice.studentInvoices, 'id', 'desc');
            }
        },
        methods: {
            handleShowStudentInvoice() {
                this.$wApi.send(this.$parentInfo.path, 'showStudentInvoice', {
                    'student_id': this.$parentInfo.student_id
                });
            },
            handleStudentInvoiceDetail(invoice) {
                this.$parentInfo.dialog_InvoiceDetail.showOn = false;
                this.$parentInfo.dialog_InvoiceDetail.loading = true;
                if(invoice.prefix=='R'){
                    this.$Win.openModal('Dialog_LeaseInvoiceDetail', 760, 800, '合同详情', {
                        'invoice_id': invoice.id,
                    });
                }else{
                    this.$Win.openModal('Dialog_InvoiceDetail', 760, 800, '合同详情', {
                        'invoice_id': invoice.id,
                    });
                }
            },
            handleInvoiceBill(invoice_id) {
                this.$Win.openModal('Dialog_InvoiceBill', 760, 900, '合同票据', {
                    'invoice_id': invoice_id,
                });
            },
            handleCancelInvoice(invoice_id) {
                this.$confirm('确认取消?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'cancelInvoice', {
                        'invoice_id': invoice_id,
                        'student_id': this.$parentInfo.student_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

            }
        }
    };
</script>

<style scoped>
</style>
